import { Link as RouterLink, type LinkProps } from 'react-router';
import { cn } from '../../lib/utils.ts';

export const Link = ({ className, children, ...props }: LinkProps) => {
  return (
    <RouterLink
      className={cn(
        'text-foreground underline-offset-4 hover:underline',
        className,
      )}
      {...props}
    >
      {children}
    </RouterLink>
  );
};
